// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3uUjA","inputDescription":"styles_inputDescription__1AYuQ"};